module.exports = __webpack_public_path__ + "static/media/garantia.0b1336fb.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/comparative/eshopex/garantia.png
// module id = 1209
// module chunks = 0